import { docReady } from '../helpers/docReady';
import automaticUnitPricing from '../components/product-unit-pricing';
import productGalleryThumbnails from '../components/product-thumbnails';
import initCustomiser from '../customiser/index';
docReady(() => {
    automaticUnitPricing();
    productGalleryThumbnails();
    initCustomiser();
});
